module.exports = "https://r.zoocdn.com/_next/static/images/hero-1600-aa41c0b191dce96d78f9ac37e36bea0d.jpg";